// src/pages/DownloadsPage.jsx
import React, { useState, useEffect } from "react";
import { useLocale } from "../contexts/LocaleContext";
import { getDownloadsPageData } from "../api/apiService";
import PageBanner from "../components/common/PageBanner";
import CategoryCard from "../components/common/CategoryCard";

function DownloadsPage() {
  const { locale } = useLocale();
  const [downloadsPageData, setDownloadsPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPageData = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getDownloadsPageData(locale);
        setDownloadsPageData(data);
      } catch (err) {
        setError(err.message || "Failed to load download content.");
        setDownloadsPageData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchPageData();
  }, [locale]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[calc(100vh-200px)]">
        <p className="text-xl text-gray-500">Loading...</p>
      </div>
    );
  }
  if (error) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-red-500 text-xl">Error: {error}</p>
      </div>
    );
  }
  if (!downloadsPageData) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-gray-700 text-xl">Download Page not available.</p>
      </div>
    );
  }

  const { banner, download_categories } = downloadsPageData;

  return (
    <div className="bg-gray-50 min-h-screen">
      <PageBanner
        title={banner?.title}
        imageUrl={banner?.image?.url}
        titleColorIsWhite={banner?.titleColorIsWhite ?? true}
        bannerHeightClass="h-52 sm:h-60 md:h-64 lg:h-72"
      />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        {download_categories && download_categories.length > 0 ? (
          <div className="space-y-8 md:space-y-12 lg:space-y-16">
            {download_categories.map((category) => (
              <CategoryCard
                key={category.id || category.name}
                category={category}
                type="download"
              />
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-600 text-lg">
            No download categories found.
          </p>
        )}
      </div>
    </div>
  );
}

export default DownloadsPage;
